var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-wrapper"},[_c('section',{staticClass:"login-container"},[_c('div',{staticClass:"welcome-section"},[_c('FormWelcome')],1),_c('div',{staticClass:"form-section"},[_c('FormLogin')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }